import React from 'react';
import { EllipsisToXIcon } from '@repo/icons/EllipsisToXIcon';

export const IntegrationActionsTrigger = ({ isOpen }: { isOpen: boolean }) => (
  <EllipsisToXIcon isOpen={isOpen} containerWidth={12} containerHeight={12} hoverOpacity={false} />
);
